// extracted by mini-css-extract-plugin
module.exports = {"HeroControls":"az_ODc","Counter":"az_PDc","PauseButton":"az_QDc","Light":"az_RDc","Dark":"az_SDc"};